import * as React from 'react';
import { PdsIconMic as PdsIconMicElement } from '@principal/design-system-icons-web';
import { IconSize, ValidIconColor } from '../../../utils/icon-utilities';
import { createPdsReactComponent } from '../../../../../react/src/lib/create-pds-react-component';

interface IconProps {
  size?: IconSize;
  color?: ValidIconColor;
}

export const PdsIconMic = createPdsReactComponent<IconProps>()({
  tagName: 'pds-icon-mic',
  elementClass: PdsIconMicElement,
  react: React,
});
